import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IPrefixesPanelButtonProps } from './types';
import { BOARD_SECTION_PREFIXES } from '../../constants';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export function PrefixesPanelButton ({
    indicatorBoolean,
    isDisabled,
    isEssentialFeature,
    tooltip,
    onClick
}: IPrefixesPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.CARD_PREFIXES}
            indicatorBoolean={indicatorBoolean}
            isDisabled={isDisabled}
            isEssentialFeature={isEssentialFeature}
            title={BOARD_SECTION_PREFIXES}
            tooltip={tooltip}
            onClick={() => {
                setSubTab(EBoardSetting.CARD_PREFIXES);
                onClick();
            }}
        />
    );
}
